import { type FunctionComponent } from 'react';
import { BrandLinks } from '../../../../../components/product-components/brand-links/brand-links.component';
import { ManufacturerResources } from '../../../../../components/product-components/manufacturer-resource/manufacturer-resource.component';
import { ProductAttributes } from '../../../../../components/product-components/product-attributes/product-attributes.component';
import { ProductDescription } from '../../../../../components/product-components/product-description/product-description.component';
import { RelatedCategoriesPanel } from '../../../../../components/product-components/related-categories-panel/related-categories-panel.component';
import { type PdpProductFamily } from '../../../../../types/product.types';

type ProductOverviewProps = {
	product: PdpProductFamily;
};

export const ProductOverview: FunctionComponent<ProductOverviewProps> = ({ product }) => {
	return (
		<div className="flex flex-wrap f5" data-testid="product-overview-body">
			<div className="w-100 w-two-thirds-ns pr3">
				{product.description && <ProductDescription description={product.description} />}
				<div className="mt3 dn-p">
					<BrandLinks brand={product.brandInfo} collection={product.collection} />
				</div>
			</div>
			<div className="w-100 w-third-ns">
				<div className="dn-p">
					{product.resources && product.resources.length > 0 && <ManufacturerResources resources={product.resources} />}
				</div>
				{product.attributeGroups?.map((attributeGroup) => (
					<div className="page-avoid-p" key={attributeGroup.name}>
						<ProductAttributes headingValue="h3" attributeGroup={attributeGroup} />
					</div>
				))}
				<div className="mt3 dn-p">
					<RelatedCategoriesPanel brand={product.brandInfo} categories={product.relatedCategories} />
				</div>
			</div>
		</div>
	);
};
